import { stringValue } from 'vega-util';
import { TUPLE } from '..';
import { varName } from '../../../util';
import { assembleInit } from '../assemble';
import nearest from './nearest';
import { TUPLE_FIELDS } from './project';
import { isLegendBinding } from '../../../selection';
var inputBindings = {
  has: function has(selCmpt) {
    return selCmpt.type === 'single' && selCmpt.resolve === 'global' && selCmpt.bind && selCmpt.bind !== 'scales' && !isLegendBinding(selCmpt.bind);
  },
  parse: function parse(model, selCmpt, selDef, origDef) {
    // Binding a selection to input widgets disables default direct manipulation interaction.
    // A user can choose to re-enable it by explicitly specifying triggering input events.
    if (!origDef.on) delete selCmpt.events;
    if (!origDef.clear) delete selCmpt.clear;
  },
  topLevelSignals: function topLevelSignals(model, selCmpt, signals) {
    var name = selCmpt.name;
    var proj = selCmpt.project;
    var bind = selCmpt.bind;
    var init = selCmpt.init && selCmpt.init[0]; // Can only exist on single selections (one initial value).
    var datum = nearest.has(selCmpt) ? '(item().isVoronoi ? datum.datum : datum)' : 'datum';
    proj.items.forEach(function (p, i) {
      var _a, _b;
      var sgname = varName("".concat(name, "_").concat(p.field));
      var hasSignal = signals.filter(function (s) {
        return s.name === sgname;
      });
      if (!hasSignal.length) {
        signals.unshift(Object.assign(Object.assign({
          name: sgname
        }, init ? {
          init: assembleInit(init[i])
        } : {
          value: null
        }), {
          on: selCmpt.events ? [{
            events: selCmpt.events,
            update: "datum && item().mark.marktype !== 'group' ? ".concat(datum, "[").concat(stringValue(p.field), "] : null")
          }] : [],
          bind: (_b = (_a = bind[p.field]) !== null && _a !== void 0 ? _a : bind[p.channel]) !== null && _b !== void 0 ? _b : bind
        }));
      }
    });
    return signals;
  },
  signals: function signals(model, selCmpt, _signals) {
    var name = selCmpt.name;
    var proj = selCmpt.project;
    var signal = _signals.filter(function (s) {
      return s.name === name + TUPLE;
    })[0];
    var fields = name + TUPLE_FIELDS;
    var values = proj.items.map(function (p) {
      return varName("".concat(name, "_").concat(p.field));
    });
    var valid = values.map(function (v) {
      return "".concat(v, " !== null");
    }).join(' && ');
    if (values.length) {
      signal.update = "".concat(valid, " ? {fields: ").concat(fields, ", values: [").concat(values.join(', '), "]} : null");
    }
    delete signal.value;
    delete signal.on;
    return _signals;
  }
};
export default inputBindings;